import script from "./SettingsOrderingDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsOrderingDelivery.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AmountField from "@/components/neue/wizard/AmountField.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import SaveBar from "@/components/SaveBar.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
script.components = Object.assign({}, { AmountField, NeueLoading, SaveBar, SelectInput, SettingsSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AmountField, NeueLoading, SaveBar, SelectInput, SettingsSection }, script.__o.components);}